const Demos = () => {
  const demos = [
    {
      title: 'New Demo',
      src:
        'https://app.supademo.com/embed/cmmasrk2m02ytx80hhxdqkrwm?embed_v=2&utm_source=embed',
    },
  ];

  return (
    <section className="blog p-top-70">
      <div className="container">
        <div className="row">
          <div className="col-12">
            <div className="heading mb-40">
              <p className="heading-subtitle">Product demos</p>
              <h2 className="heading-title">Interactive walkthroughs</h2>
              <p className="heading-desc">
                These demos are embedded from Supademo. If you can’t see a demo, try disabling tracking blockers for
                this page.
              </p>
            </div>
          </div>
        </div>

        {demos.map((demo) => (
          <div className="row" key={demo.src} style={{ marginBottom: 48 }}>
            <div className="col-12 col-lg-8">
              <h3 style={{ marginBottom: 16 }}>{demo.title}</h3>
              <div
                style={{
                  position: 'relative',
                  boxSizing: 'content-box',
                  maxHeight: '80vh',
                  width: '100%',
                  aspectRatio: '0.46',
                  padding: '40px 0 40px 0',
                }}
              >
                <iframe
                  src={demo.src}
                  loading="lazy"
                  title={demo.title}
                  allow="clipboard-write"
                  frameBorder="0"
                  allowFullScreen
                  style={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%' }}
                ></iframe>
              </div>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};

export default Demos;
